import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { Link } from 'wouter';

export function CTA() {
  const { t } = useTranslation();
  
  return (
    <section className="py-20 bg-slate-900 text-white text-center px-4 md:px-8 lg:px-16">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-extrabold mb-4 tracking-tight">
          {t('cta.title', 'Secure Your Facilities')}
        </h2>
        <p className="text-lg opacity-90 mb-8 max-w-2xl mx-auto">
          {t('cta.description', 'Discover how Oleyes fire detection can protect your facilities. Contact us for a personalized demonstration.')}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link href="/free-trial">
            <button className="px-8 py-4 rounded-lg bg-white text-slate-900 font-bold text-base shadow-lg hover:bg-slate-100 transition-all border-2 border-white">
              {t('cta.primaryButton', 'Request a Demo')}
              <ArrowRight className="ml-2 h-4 w-4 inline" />
            </button>
          </Link>
          <Link href="/contact-sales">
            <button className="px-8 py-4 rounded-lg bg-transparent text-white font-bold text-base border-2 border-white hover:bg-white hover:text-slate-900 transition-all">
              {t('cta.secondaryButton', 'Contact Us')}
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default CTA;
